import { privacyMeta } from "@constants/legal";
import { useAppStore } from "@hooks/useAppStore";
import LegalView from "@memorang/ui/components/LegalView";

const PrivacyRoute = () => {
	const appName = useAppStore((store) => store.app.name);
	const baseUrl = useAppStore((store) => store.app.links.baseUrl);
	const supportEmail = useAppStore((store) => store.supportEmail);

	const processedText = privacyMeta.privacy
		.replace(/\{\{appName\}\}/g, appName)
		.replace(/\{\{baseUrl\}\}/g, baseUrl || "memorang.com")
		.replace(
			/\{\{supportEmail\}\}/g,
			supportEmail || "support@mail.memorang.com",
		);

	return (
		<LegalView
			dates={privacyMeta.dates}
			text={processedText}
			title={privacyMeta.title.replace("{{appName}}", appName)}
		/>
	);
};

export default PrivacyRoute;
